import React from 'react';
import { TableCell } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Table';
import { buildElementStyling } from '../utils';
import { renderedTableHeadings } from './TableHeading';
const RichTextTableCell = ({ children, value, index }) => {
    const { className, style } = buildElementStyling({
        baseClass: 'richTextTableCell',
        value,
    });
    return (React.createElement(TableCell, { className: className, style: style, verticalAlign: "top", styleAs: "paragraphSmallLight", "data-heading-label": renderedTableHeadings[index] }, children));
};
RichTextTableCell.displayName = 'RichTextTableCell';
export default RichTextTableCell;
//# sourceMappingURL=TableCell.js.map